import {Scene} from 'phaser';
import {getReadableColor} from "src/game/GameHelper";

export class GTGPreloader extends Scene {
  constructor() {
    super('GTGPreloader');
  }

  init() {
    const gameWidth = this.game.config.width;
    const gameHeight = this.game.config.height;
    const readableColor = getReadableColor(this.game.options.themeColor);

    const dynamicColor = Phaser.Display.Color.HexStringToColor(this.game.options.themeColor).color; // Convert hex string to Phaser color
    const graphics = this.add.graphics();
    graphics.fillStyle(dynamicColor, 0.7);
    graphics.fillRect(0, 0, gameWidth, gameHeight);

    const barWidth = gameWidth - 200;
    const innerBarWidth = barWidth - 16;
    this.add.rectangle(gameWidth / 2, gameHeight - 200, barWidth, 40).setStrokeStyle(4, Phaser.Display.Color.HexStringToColor(readableColor).color);
    const bar = this.add.rectangle((gameWidth - innerBarWidth) / 2, gameHeight - 200, 4, 30, Phaser.Display.Color.HexStringToColor(readableColor).color);
    this.load.on('progress', (progress) => {
      bar.width = 4 + (innerBarWidth * progress);
    });
  }

  preload() {
    let bgAudioUrl = null;
    let carTopImageUrl = null;
    let bonusImageUrl = null;
    let adImageUrl1 = null;
    let adImageUrl2 = null;
    const options = this.game.options;
    if (options) {
      if (options.images && options.images.length > 0) {
        options.images.forEach((item) => {
          if (item.url && (item.url.startsWith('file:') || item.url.startsWith('blob:') || item.url.startsWith('http:') || item.url.startsWith('https:'))) {
            if (item.number === 0) {
              carTopImageUrl = item.url;
            } else if (item.number === 1) {
              bonusImageUrl = item.url;
            } else if (item.number === 2) {
              adImageUrl1 = item.url;
            } else if (item.number === 3) {
              adImageUrl2 = item.url;
            }
          }
        });
      }
      if (options.audios && options.audios.length > 0) {
        options.audios.forEach((item) => {
          if (item.url && (item.url.startsWith('file:') || item.url.startsWith('blob:') || item.url.startsWith('http:') || item.url.startsWith('https:'))) {
            if (item.number === 0) {
              bgAudioUrl = item.url;
            }
          }
        });
      }
    }

    this.load.setPath('media/gameTrafficGo');

    this.load.image('carTop', carTopImageUrl || 'carTop.png');
    this.load.image('raw_bonus', bonusImageUrl || 'bonus.png');
    this.load.image('adImage1', adImageUrl1 || 'adImage1.png');
    this.load.image('adImage2', adImageUrl2 || 'adImage2.png');

    this.load.image('roadCurve', 'roadCurve.png');
    this.load.image('raw_car', 'car.png');
    this.load.image('carBlue', 'carBlue.png');
    this.load.image('carCop', 'carCop.png');
    this.load.image('pickupTruck', 'pickupTruck.png');
    this.load.image('truck', 'truck.png');
    this.load.image('crash', 'crash.png');
    this.load.image('plus', 'plus.png');
    this.load.image('finish', 'finish.png');

    if (!options.simulation) {
      this.load.audio('audio_bg', bgAudioUrl || 'audios/audio_bg.m4a');
      this.load.audio('audio_play', 'audios/audio_play.mp3');
      this.load.audio('audio_crash', 'audios/audio_crash.mp3');
      this.load.audio('audio_bonus', 'audios/audio_bonus.mp3');
      this.load.audio('audio_game_end', 'audios/audio_game_end.wav');
      this.load.audio('audio_game_win', 'audios/audio_game_win.mp3');
    }
  }

  create() {
    const renderTextureScorer = this.make.renderTexture({x: 0, y: 0, width: 90, height: 126}, false);
    const imageScorer = this.add.image(45, 45, 'raw_bonus')
      .setDisplaySize(90, 90)
      .setVisible(false);
    const imagePlus = this.add.image(24, 18, 'plus')
      .setDisplaySize(49, 36)
      .setVisible(false);
    renderTextureScorer.draw(imageScorer, 45, 78, 1);
    renderTextureScorer.draw(imagePlus, 45, 18, 1);
    renderTextureScorer.saveTexture('bonus');
    imageScorer.destroy(true);
    imagePlus.destroy(true);
    renderTextureScorer.destroy(true);

    const carWidth = 168 - 18;
    const carHeight = carWidth*1.8;
    const carTopSize = carWidth*.6;
    const renderTexture1 = this.make.renderTexture({x: 0, y: 0, width: carWidth, height: carHeight}, false);
    const image11 = this.add.image(0, 0, 'raw_car')
      .setDisplaySize(carWidth, carHeight)
      .setVisible(false);
    const image12 = this.add.image(0, 0, 'carTop')
      .setDisplaySize(carTopSize, carTopSize)
      .setVisible(false);
    renderTexture1.draw(image11, carWidth/2, carHeight/2, 1);
    renderTexture1.draw(image12, carWidth/2, carHeight*.58, 1);
    renderTexture1.saveTexture('car');
    image11.destroy(true);
    image12.destroy(true);
    renderTexture1.destroy(true);

    this.scene.start('GTGGame');
  }
}
